import { observer } from 'mobx-react-lite'
import { type FC, type ReactNode } from 'react'
import { TextField } from 'shared/ui/TextField'
import { DropdownContent, Scrollbar } from 'shared/ui'
import { type IResponseVoice } from 'entities/TextToSpeech'
import {
  type IVoiceItemProps,
  VoiceItem,
} from 'widgets/TextToSpeech/ui/TextToSpeechVoice/VoicesContent/VoiceItem/VoiceItem'
import styles from './styles.module.scss'

type IVoicesContentProps = {
  onCloseMenu: () => void
  search: string
  setSearch: (value: string) => void
  tabContent?: ReactNode
  voices: IResponseVoice[]
  bottomContent?: ReactNode
  voiceItemProps: (item: IResponseVoice) => Omit<IVoiceItemProps, 'voice' | 'onCloseMenu'>
}

export const VoicesContent: FC<IVoicesContentProps> = observer(
  ({ onCloseMenu, search, setSearch, tabContent, voices, bottomContent, voiceItemProps }) => {
    return (
      <DropdownContent noPadding>
        <div className={styles.wrap}>
          <div className={styles.header}>
            <TextField
              variant={'integrated'}
              InputProps={{
                placeholder: 'Search',
              }}
              value={search}
              onChange={setSearch}
            />
          </div>
          {tabContent}
          <div className={styles.content}>
            <Scrollbar autoHeight autoHeightMin={0} autoHeightMax={192}>
              {voices.map((voice) => (
                <VoiceItem
                  key={voice.id}
                  voice={voice}
                  onCloseMenu={onCloseMenu}
                  {...voiceItemProps(voice)}
                />
              ))}
              {bottomContent}
            </Scrollbar>
          </div>
        </div>
      </DropdownContent>
    )
  }
)
